import Vue from "vue";
import Router from "vue-router";
import Login from "@/components/login";
import Details from "@/components/details";
import reprintDetails from "@/components/reprintDetails";
import qrCode from "@/components/qrCode";
import ManualLogin from "@/components/ManualLogin";
import ReprintManualLogin from "@/components/ReprintManualLogin";
import ShowTime from "@/components/ShowTime";
import Home from "../components/home.vue";

Vue.use(Router);

const ifNotAuthenticated = (to, from, next) => {
  if (Vue.cookie.get("BRHSID") && window.localStorage.getItem("JWT_TOKEN")) {
    return next();
  } else return next("/login");
};

const redirectToPage = (to) => {
  if (
    !Vue.cookie.get("BRHSID") ||
    !Vue.cookie.get("BRLF") ||
    !window.localStorage.getItem("JWT_TOKEN")
  ) {
    window.localStorage.clear();
    Vue.cookie.delete("BRHSID");
    Vue.cookie.delete("BRLF");
  }
  return Vue.cookie.get("BRHSID") &&
    Vue.cookie.get("BRLF") &&
    window.localStorage.getItem("JWT_TOKEN")
    ? "/" + (Vue.cookie.get("BRIJ_DEFAULT_PAGE") || "home")
    : "/login";
};

export const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/login",
      name: "login",
      component: Login,
    },
    {
      path: "/home",
      name: "Home",
      component: Home,
    },
    {
      path: "/details",
      name: "details",
      component: Details,
    },
    {
      path: "/reprintDetails",
      name: "reprintDetails",
      component: reprintDetails,
    },
    {
      path: "/qrCode",
      name: "qrCode",
      component: qrCode,
    },
    {
      path: "/manual",
      name: "manual",
      component: ManualLogin,
    },
    {
      path: "/reprint-manual",
      name: "reprint-manual",
      component: ReprintManualLogin,
    },
    {
      path: "/showtime",
      name: "showtime",
      component: ShowTime,
    },
    {
      path: "*",
      beforeEnter: ifNotAuthenticated,
      redirect: redirectToPage,
      name: "login",
      component: Login,
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to && to.name.toLowerCase() == "login") {
    if (Vue.cookie.get("BRHSID") && window.localStorage.getItem("JWT_TOKEN")) {
      const defaultPage = "/" + (Vue.cookie.get("BRIJ_DEFAULT_PAGE") || "home");
      return next(defaultPage);
    } else {
      return next();
    }
  } else {
    if (Vue.cookie.get("BRHSID") && window.localStorage.getItem("JWT_TOKEN")) {
      return next();
    } else {
      return next("/login");
    }
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js